import React from 'react';
import PropTypes from 'prop-types';

import { AppointmentTimeForm } from '@components';

export class Schedules extends React.Component {
  handleCancel = e => {
    e.preventDefault();

    const {
      form: { setFields },
      // schedules,
      handleFormToggle,
    } = this.props;

    setFields({});
    handleFormToggle();
  };

  render() {
    const { form, editFormIsOpen, handleFormToggle, schedules } = this.props;
    return (
      <div>
        <AppointmentTimeForm
          schedules={schedules}
          form={form}
          editFormIsOpen={editFormIsOpen}
          handleEditFormToggle={handleFormToggle}
          handleCancel={this.handleCancel}
        />
      </div>
    );
  }
}

export default Schedules;

Schedules.propTypes = {
  schedules: PropTypes.array.isRequired,
  form: PropTypes.object.isRequired,
  editFormIsOpen: PropTypes.bool.isRequired,
  handleFormToggle: PropTypes.func.isRequired,
};
